var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E9FBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2201_19960",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2201_19960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8666 15.8673C11.1443 14.9007 11.7082 13.8757 12.5582 12.7923C13.4082 11.709 14.5555 10.5562 15.9999 9.33398C17.4443 10.5562 18.5916 11.709 19.4416 12.7923C20.2916 13.8757 20.8555 14.9007 21.1332 15.8673H19.7332C19.4777 15.1784 19.0388 14.4368 18.4166 13.6423C17.7943 12.8479 16.9888 12.0007 15.9999 11.1007C15.0221 12.0007 14.2193 12.8479 13.5916 13.6423C12.9638 14.4368 12.5221 15.1784 12.2666 15.8673H10.8666ZM21.2332 18.3007C21.1332 18.8451 20.9582 19.359 20.7082 19.8423C20.4582 20.3257 20.1388 20.7618 19.7499 21.1507C19.361 21.5395 18.9249 21.8562 18.4416 22.1007C17.9582 22.3451 17.4499 22.5118 16.9166 22.6007L21.2332 18.3007ZM18.5166 17.2007H20.4166L15.0166 22.6007C14.761 22.5451 14.5138 22.4812 14.2749 22.409C14.036 22.3368 13.8055 22.2395 13.5832 22.1173L18.5166 17.2007ZM14.6999 17.2007H16.5999L12.4499 21.3507C12.2832 21.1951 12.1249 21.034 11.9749 20.8673C11.8249 20.7007 11.6888 20.5229 11.5666 20.334L14.6999 17.2007ZM10.6499 17.2007H12.7666L10.9332 19.034C10.8443 18.734 10.7777 18.4312 10.7332 18.1257C10.6888 17.8201 10.661 17.5118 10.6499 17.2007Z",
    fill: "#00A7A6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaster);
export default __webpack_public_path__ + "static/media/plaster.0878f3a6630cd7fde468c496e0c38ad4.svg";
export { ForwardRef as ReactComponent };